/**
 * Whether a page break is being drawn between two sheets.
 *
 * On the canvas a page break *is* the seam between one sheet and the next,
 * wherever it stands in the tree, so it is drawn in that seam, as a tab
 * somebody can pick up; the picture it brings is drawn by the sheet it opens.
 * Anywhere sections are drawn without sheets around them, such as the
 * specimen page in the document settings, there is no seam, so it is a rule
 * across the text with its picture laid under what follows.
 *
 * The seam knows which it is and the break does not, so the seam says so. An
 * injection rather than a prop, because between the two sit the section
 * chrome and the kind registry, and neither has any business carrying a flag
 * that only this kind reads.
 */

import type { InjectionKey } from 'vue'

export const BETWEEN_SHEETS: InjectionKey<boolean> = Symbol('between-sheets')
